import { render, staticRenderFns } from "./leftSide.vue?vue&type=template&id=1ddc5f98&scoped=true&"
import script from "./leftSide.vue?vue&type=script&lang=js&"
export * from "./leftSide.vue?vue&type=script&lang=js&"
import style0 from "./leftSide.vue?vue&type=style&index=0&id=1ddc5f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc5f98",
  null
  
)

export default component.exports